export const builderServicesPact = {
  manifest: {
    behaviors: {
      getValueFromManifest: () => undefined as any,
    },
    get: {
      customActions: () => null,
      editActions: () => null,
      displayName: () => null,
      presets: () => null,
      data: () => null,
      style: () => null,
    },
    internal: {
      loadAndResolveManifestsByCompTypes: () => {},
      getCompType: () => '',
      getPanel: () => null,
    },
    isBuilderComponentType: () => false,
    getChildren: () => [],
    getAncestors: () => [],
  },
  panels: {
    getDesignPanel: () => null,
  },
  [Symbol.for('pactBuilderServices')]: true,
};
